import { Droppable } from "@hello-pangea/dnd";

import type { Contact } from "@/components/atomic-crm/types";
import { cn } from "@/lib/utils";
import { BoardColumn, BoardDropHint } from "@/modules/shared/board";

import { LeadCard } from "./LeadCard";
import type { LeadStageDef } from "./leadStages";

export type LeadColumnProps = {
  stage: LeadStageDef;
  leads: Contact[];
  isDragging?: boolean;
  collapsed?: boolean;
  onToggleCollapse?: () => void;
};

export const LeadColumn = ({
  stage,
  leads,
  isDragging = false,
  collapsed = false,
  onToggleCollapse,
}: LeadColumnProps) => {
  return (
    <BoardColumn
      label={stage.label}
      color={stage.color}
      count={leads.length}
      collapsed={collapsed}
      onToggleCollapse={onToggleCollapse}
    >
      <div className="flex min-h-0 flex-1 flex-col">
        <Droppable droppableId={stage.id}>
          {(droppableProvided, snapshot) => (
            <div
              ref={droppableProvided.innerRef}
              {...droppableProvided.droppableProps}
              className="flex min-h-[10rem] flex-1 flex-col"
            >
              <div
                data-kanban-cards
                data-column-scroll
                className={cn(
                  "flex min-h-0 flex-1 flex-col gap-2 rounded-xl p-2 transition-colors",
                  isDragging
                    ? "overflow-hidden"
                    : "overflow-y-auto overscroll-y-contain",
                  snapshot.isDraggingOver && "bg-primary/5",
                )}
              >
                {collapsed
                  ? null
                  : leads.map((lead, index) => (
                      <LeadCard key={lead.id} lead={lead} index={index} />
                    ))}
                {!collapsed && leads.length === 0 ? (
                  <BoardDropHint>
                    Drop a lead here to move to{" "}
                    <span className="font-medium">{stage.label}</span>
                  </BoardDropHint>
                ) : null}
                {droppableProvided.placeholder}
              </div>
            </div>
          )}
        </Droppable>
      </div>
    </BoardColumn>
  );
};
